import {
  CancellationRefundBody,
  FetchRefundParams,
  ListData,
  Refund,
} from "@/types";
import axiosInstance from "./api";

export function fetchListRefundService(
  params: FetchRefundParams,
): Promise<ListData<Refund>> {
  return axiosInstance
    .get("/booking-cancellation", { params })
    .then((response) => response.data);
}

export function cancellationStatusService(
  body: CancellationRefundBody,
): Promise<Refund> {
  return axiosInstance
    .patch("/booking-cancellation/statuses", { ...body })
    .then((response) => response.data);
}
